import { http } from '@/http'

export default {
  list(params)             { return http.get('/work-sites', { params }) },
  listByCompany(id)        { return http.get(`/work-sites/company/${id}`) },
  listByCompanyAndStatus(id, status) { return http.get('/work-sites', { params: { companyId: id, status } }) },
  get(id)                  { return http.get(`/work-sites/${id}`) },
  save(data)               { return http.post('/work-sites', data) },
  update(id, data)         { return http.put(`/work-sites/${id}`, data) },
  changeStatus(id, status) { return http.put(`/work-sites/${id}/status`, null, { params: { status } }) },
}
